const APP_VERSION = 'p-release-r30';

const AXIS = {
    X: {
        key: 'X',
        name: 'Conversation',
        sysName: 'conversation'
    },
    Y: {
        key: 'Y',
        name: 'Quality',
        sysName: 'quality'
    },
    Z: {
        key: 'Z',
        name: 'Community',
        sysName: 'community'
    },
    P: {
        key: 'P',
        name: 'Pillar'
    }
};

const PROJECT_STATE = {
    DRAFT: 'Draft',
    PUBLISHED: 'Published',
    ARCHIVED: 'Archived',
    PUBLISHING: 'Publishing'
};

const CURRENT_PROJECT_VERSION = 2;

const PERIOD = {
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month',
    QUARTER: 'quarter',
    YEAR: 'year'
};

const DAY = {
    SATURDAY: 'saturday',
    SUNDAY: 'sunday',
    MONDAY: 'monday'
};

const ST_PAGE_LINKS = {
    FACEBOOK: 'https://www.mysocialtools.net/brands/charts/facebook-',
    TWITTER: 'https://www.mysocialtools.net/brands/charts/twitter-',
    YOUTUBE: 'https://www.mysocialtools.net/brands/charts/youtube-',
    INSTAGRAM: 'https://www.mysocialtools.net/brands/charts/instagram-'
};

const ST_NETWORK_TYPE = {
    FACEBOOK: 'Facebook',
    TWITTER: 'Twitter',
    YOUTUBE: 'YouTube',
    INSTAGRAM: 'Instagram'
};

const DATE_QUICK_SELECTIONS = {
    LAST_SEVEN_DAYS: { key: '7days', name: 'Last 7 Days', order: 1 },
    LAST_THIRTY_DAYS: { key: '30days', name: 'Last 30 Days', order: 2 },
    LAST_NINETY_DAYS: { key: '90days', name: 'Last 90 Days', order: 3 },
    LAST_ONE_HUNDRED_EIGHTY_DAYS: { key: '180days', name: 'Last 180 Days', order: 4 },
    CUSTOM: { key: 'custom', name: 'Custom', order: 9 }
};

const EXCEL_EXPORT_SHEET_TYPES = {
    INFO_SHEET: 'info-sheet',
    RAW_DATA_SHEET: 'raw-data-sheet',
    NORMALISED_DATA_SHEET: 'normalised-data-sheet',
    NORMALISED_AND_WEIGHTED_DATA_SHEET: 'normalised-and-weighted-data-sheet',
    FINAL_SCORE_SHEET: 'final-score-sheet'
};

const TOPIC_AND_PAGE_STATE = {
    AVAILABLE: 'AVAILABLE',
    UNAVAILABLE: 'UNAVAILABLE',
    NOT_CHECKED: 'NOT_CHECKED'
};

export default {
    APP_VERSION: APP_VERSION,
    AXIS: AXIS,
    PROJECT_STATE: PROJECT_STATE,
    CURRENT_PROJECT_VERSION: CURRENT_PROJECT_VERSION,
    PERIOD: PERIOD,
    DAY: DAY,
    ST_PAGE_LINKS: ST_PAGE_LINKS,
    ST_NETWORK_TYPE: ST_NETWORK_TYPE,
    DATE_QUICK_SELECTIONS: DATE_QUICK_SELECTIONS,
    EXCEL_EXPORT_SHEET_TYPES,
    TOPIC_AND_PAGE_STATE: TOPIC_AND_PAGE_STATE
};
